// @flow

import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";

const markInventoryOrderCartonAsReceivedAndLocated: any = graphql(
  gql`
    mutation ($inventoryOrderCartonIdentifier: String!, $location: String!) {
      markInventoryOrderCartonAsReceivedAndLocated(inventoryOrderCartonIdentifier: $inventoryOrderCartonIdentifier, location: $location) {
        errors {
          inventoryOrderCartonIdentifier
          location
        }
        errorStatus
        succeeded
        updatedInventoryOrderCartons {
          id
          name
          orderProductionJob {
            id
            label
            customizationAreas {
              method
            }
            order {
              id
              orderNumber
              express
            }
          }
          inventoryOrderItem {
            id
            inventoryOrder {
              id
              poNumber
            }
          }
        }
      }
    }
  `,
  {
    name: "markInventoryOrderCartonAsReceivedAndLocated"
  }
);

export default markInventoryOrderCartonAsReceivedAndLocated;
